import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api, qs } from "@/lib/api";
import { Card } from "@/components/Kpi";
import { dateIt, eur, num } from "@/lib/format";

/** Dettaglio per convenzionato delle pratiche di un giorno (caricate o liquidate). */
export function DettaglioGiorno({ data, tipo, filters, onClose }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    const f = { ...filters, mese: undefined, anno: undefined };
    api.get(`/dashboard/giornaliero/dettaglio?${qs({ ...f, data, tipo })}`).then((r) => setD(r.data)).catch(() => setD({ dealers: [] }));
  }, [data, tipo, filters]);

  const caricato = tipo === "caricato";
  const t = d?.totali || {};
  const th = "px-3 py-2 text-xs font-semibold uppercase tracking-wider text-slate-500";
  const td = "px-3 py-2 text-sm";
  return (
    <Card className="p-0 overflow-hidden" data-testid="dettaglio-giorno">
      <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200 bg-slate-50/70">
        <div className="text-sm font-semibold text-slate-800">
          {caricato ? "Pratiche caricate" : "Pratiche liquidate"} il {dateIt(data)}
          {d && <span className="ml-2 text-slate-400 font-normal">· {d.dealers.length} convenzionati</span>}
        </div>
        <button type="button" onClick={onClose} data-testid="dettaglio-giorno-chiudi"
          className="text-slate-400 hover:text-slate-700 transition-colors duration-200"><X size={16} /></button>
      </div>
      {!d ? (
        <div className="px-4 py-6 text-sm text-slate-400">Caricamento…</div>
      ) : !d.dealers.length ? (
        <div className="px-4 py-6 text-sm text-slate-400" data-testid="dettaglio-giorno-vuoto">Nessuna pratica in questo giorno</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b border-slate-200">
                <th className={`${th} text-left`}>Convenzionato</th>
                <th className={`${th} text-right`}>{caricato ? "Caricate" : "Liquidate"}</th>
                {caricato && <th className={`${th} text-right`}>Approvate</th>}
                <th className={`${th} text-right`}>{caricato ? "Importo caricato" : "Importo liquidato"}</th>
                {caricato && <th className={`${th} text-right`}>Importo approvato</th>}
              </tr>
            </thead>
            <tbody>
              {d.dealers.map((r) => (
                <tr key={r.dealer_codice} className="border-b border-slate-100 hover:bg-slate-50 transition-colors duration-150"
                  data-testid={`dettaglio-giorno-riga-${r.dealer_codice}`}>
                  <td className={`${td} text-slate-800`}>{r.dealer_nome}
                    <span className="ml-2 text-xs text-slate-400 font-mono">{r.dealer_codice}</span></td>
                  <td className={`${td} text-right font-mono`}>{num(r.pratiche)}</td>
                  {caricato && <td className={`${td} text-right font-mono text-emerald-700`}>{num(r.approvate)}</td>}
                  <td className={`${td} text-right font-mono`}>{eur(r.importo)}</td>
                  {caricato && <td className={`${td} text-right font-mono text-emerald-700`}>{eur(r.importo_approvato)}</td>}
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr className="bg-slate-50 font-semibold" data-testid="dettaglio-giorno-totale">
                <td className={`${td} text-slate-700`}>Totale</td>
                <td className={`${td} text-right font-mono`}>{num(t.pratiche)}</td>
                {caricato && <td className={`${td} text-right font-mono text-emerald-700`}>{num(t.approvate)}</td>}
                <td className={`${td} text-right font-mono`}>{eur(t.importo)}</td>
                {caricato && <td className={`${td} text-right font-mono text-emerald-700`}>{eur(t.importo_approvato)}</td>}
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </Card>
  );
}
